export default "__VITE_ASSET__DMVB2Z6Y__"